import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import App from './App.tsx';
import './index.css';

// Register PWA Service Worker (only in production)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SWRConfig
      value={{
        // 全局配置，防止重复请求
        dedupingInterval: 10000, // 10秒内相同请求去重
        revalidateOnFocus: false, // 禁用焦点时重新验证
        revalidateOnReconnect: true, // 保留网络重连时的重新验证
        refreshInterval: 0, // 禁用自动刷新
        errorRetryCount: 2, // 错误重试次数
        errorRetryInterval: 2000, // 错误重试间隔
        keepPreviousData: true, // 保持之前的数据
        onError: (error, key) => {
          console.error('SWR Global Error:', error, 'Key:', key);
        },
      }}
    >
      <App />
    </SWRConfig>
  </StrictMode>
);
